import { onMounted, onBeforeUnmount, ref, reactive, watch } from 'vue';
import { useHomeStore } from "../../../store/home"; //引入home仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import { useRouter, useRoute } from "vue-router";
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/effect-fade/effect-fade.min.css'; //引入轮播样式-

import 'swiper/modules/pagination/pagination.min.css';
import { it } from 'element-plus/lib/locale';
export default {
  name: 'Manage',
  components: {
    Swiper: Swiper,
    SwiperSlide: SwiperSlide
  },
  setup: function setup() {
    // swiper配置项
    var num = ref(3); // 根据视口宽度动态修改 swiper 展示数量

    var viewportWidth = ref(window.innerWidth);

    var updateViewportWidth = function updateViewportWidth() {
      viewportWidth.value = window.innerWidth;
    };

    watch(viewportWidth, function (newValue) {
      if (newValue > 1000) {
        num.value = 3;
      }

      if (newValue < 1000) {
        num.value = 2;
      }

      if (newValue < 768) {
        num.value = 1;
      }
    });
    var store = useHomeStore(); // 在组件挂载后开始监听窗口大小变化

    onMounted(function () {
      window.addEventListener('resize', updateViewportWidth);

      if (viewportWidth.value > 1000) {
        num.value = 3;
      }

      if (viewportWidth.value < 1000) {
        num.value = 2;
      }

      if (viewportWidth.value < 768) {
        num.value = 1;
      }

      store.getHomePipelineInnovationList();
    }); // let { InnovationList } = storeToRefs(store) //从仓库获取数据
    // 在组件卸载前移除事件监听器

    onBeforeUnmount(function () {
      window.removeEventListener('resize', updateViewportWidth);
    });
    var swiper_option = reactive({
      autoplay: {
        delay: 3500,
        disableOnInteraction: false
      },
      fadeEffect: {
        crossFade: false
      },
      loop: true,
      speed: 1000,
      liner: true,
      showNum: num.value // on: {
      //   slideChangeTransitionEnd: handleSlideChange,
      // },

    });
    watch(num, function (newValue) {
      swiper_option.showNum = newValue;
    }); // 列表数据Early Development

    var InnovationList = reactive([{
      title: 'Ztalmy<sup>®️</sup>Ganaxolone',
      engTitle: '(Ganaxolone)',
      subTitle: '(Epilepsy)',
      imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_Ganaxolone.jpg",
      id: 1
    }, {
      title: 'Ulixacaltamide',
      engTitle: ' (Movement Disorder) ',
      subTitle: '(Movement Disorder)',
      imageUrl: "https://cdn.tenacia.com/base/tenacia-img/ulixacaltamide.jpg",
      id: 2
    }, {
      title: 'PANDA Platform',
      engTitle: '(早期研发)',
      subTitle: '(Early Development)',
      imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_PANDA.jpg",
      id: 3
    }, {
      title: 'RAP-219',
      engTitle: '（癫痫）',
      subTitle: '(Epilepsy)',
      imageUrl: "https://cdn.tenacia.com/tenacia-cn/pipelineInnovation/2026/04/16/84d6fb02-a94a-4a91-80f2-d3774e2354e4.jpg",
      id: 4
    }, {
      title: 'TX301',
      engTitle: '(早期研发)',
      subTitle: '(Neuroimmunology)',
      imageUrl: "https://cdn.tenacia.com/tenacia-cn/pipelineInnovation/2025/03/20/baba5b54-d9df-40a4-8d24-49aa55df7607.jpg",
      id: 5
    }]);
    var router = useRouter();
    var route = useRoute();

    var jumpManage = function jumpManage() {
      router.push({
        path: '/pipeline',
        hash: '#manage'
      });
    };

    return {
      InnovationList: InnovationList,
      swiper_option: swiper_option,
      modules: [EffectFade, Pagination, Navigation],
      jumpManage: jumpManage
    };
  }
};